/**
 * Leituras PURAS da fila de anexos (`anexos-pendentes.js`) que o mixin de
 * upload expõe como computed — saíram de
 * `send-message-anexos-upload-mixin.js` para ele caber no teto de linhas do
 * repo. Nenhuma das duas lê `this`: recebem os mapas da fila e devolvem
 * valor novo.
 */
import { chaveDoArquivo } from '@modules/aawz-intelligence-v2/utils/chave-de-arquivo'
import { STATUS_UPLOAD } from '@modules/aawz-intelligence-v2/constants/Anexos'

const STATUS_EXIBIDOS = [STATUS_UPLOAD.ENVIANDO, STATUS_UPLOAD.ERRO]

/**
 * Uploads concluídos, na ORDEM de `arquivos` — é o que vira o `anexos` de
 * rede (`apiChat.sendMessage`). Item sem upload bem-sucedido simplesmente não
 * aparece: nunca um "anexo fantasma" no corpo do POST.
 *
 * @param {File[]} arquivos a fila visível
 * @param {Object} uploadPorChave chave → `{uploadId, nome, contentType, tamanho}`
 * @returns {Object[]}
 */
function anexosProntos(arquivos, uploadPorChave) {
  const prontos = []
  arquivos.forEach((arquivo) => {
    const upload = uploadPorChave[chaveDoArquivo(arquivo)]
    if (upload) prontos.push(upload)
  })
  return prontos
}

/**
 * Mapa pronto para `<ComposerAttachments :status-por-chave="...">` — só
 * repassa `'enviando'`/`'erro'` (o componente ignora qualquer outro valor,
 * incluindo `'sem_cliente'`: aquele estado não é uma FALHA de upload, é
 * ausência de cliente, e o aviso de texto abaixo do campo já cobre esse caso
 * sem precisar de selo por item).
 *
 * @param {Object} statusUploadPorChave chave → status
 * @returns {Object} chave → `'enviando'` | `'erro'`
 */
function statusUploadParaExibir(statusUploadPorChave) {
  const mapa = {}
  Object.keys(statusUploadPorChave).forEach((chave) => {
    const status = statusUploadPorChave[chave]
    if (STATUS_EXIBIDOS.indexOf(status) !== -1) mapa[chave] = status
  })
  return mapa
}

export { anexosProntos, statusUploadParaExibir }
